
import { Component, Vue } from "nuxt-property-decorator";
import Accordion, { AccordionToggleEvent } from "./Accordion.vue";

@Component({})
export default class AccordionGroup extends Vue {
  mounted() {
    this.$children.forEach((child: Accordion) => {
      child.$on("toggle-expanded-state", (event: AccordionToggleEvent) => {
        this.$children.forEach((child: Accordion) => {
          if (child.value === event.value) {
            child.expanded = !child.expanded;
          } else {
            child.expanded = false;
          }
        });
      });
    });
  }
}
